import {
    FETCH_OPERATING_INFO_FULFILLED,
    FETCH_OPERATING_INFO_PENDING,
    FETCH_OPERATING_INFO_REJECTED,
    
    FETCH_OPERATING_INFO_SUPPORT_FULFILLED,

    OperatingInfoAction,
} from "./action-types";

export interface IOperatingInformationState {
    currentCategories: Spintr.IOperatingInfoCategory[];
    isLoadingSidebar: boolean;
    support: Spintr.IOperatingInfoSupport[];
}

const initialState: IOperatingInformationState = {
    currentCategories: [],
    isLoadingSidebar: false,
    support: [],
};

export const operatingInfoReducer = (
    state: IOperatingInformationState = initialState, 
    action: OperatingInfoAction
) : IOperatingInformationState => {
    switch (action.type) {
        case FETCH_OPERATING_INFO_PENDING:
            return {
                ...state,
                isLoadingSidebar: true,
            };

        case FETCH_OPERATING_INFO_REJECTED:
            return {
                ...state,
                isLoadingSidebar: false,
            };

        case FETCH_OPERATING_INFO_FULFILLED:
            return {
                ...state,
                isLoadingSidebar: false,
                currentCategories:action.payload.data.map(category => {
                    category.items = category.items || [];
                    category.items.forEach(item => {
                        item.dateStart = new Date(item.dateStart);

                        if (item.dateEnd) {
                            item.dateEnd = new Date(item.dateEnd);
                        }
                    });
                    return category;
                }),
            };

        case FETCH_OPERATING_INFO_SUPPORT_FULFILLED:
            return {
                ...state,
                support: action.payload.data.support,
            };

        default:
            return state
    }
};

export default operatingInfoReducer;